import IconAsMaskImage from "../IconAsMaskImage";

const Home = ({ pureSvg, className, color }) => {
  const svg = (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.28462 21H17.7159C19.5509 21 21.0376 19.5123 21.0376 17.6783V10.5045C21.0376 9.6133 20.6367 8.76973 19.9459 8.20638L14.3718 3.66551C13.282 2.77816 11.7185 2.77816 10.6287 3.66551L5.05457 8.20638C4.36376 8.76973 3.96289 9.6133 3.96289 10.5045V17.6783C3.96289 19.5123 5.44959 21 7.28462 21Z"
        stroke="#851575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.86523 15.834H15.1378"
        stroke="#851575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
};

export default Home;
